import ListPackages from "../../../../components/@repositories/packages/ListPackages";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PackagesPage() {

    return (
        <ListPackages 
            routeType={routeTypes.workstation}
        />
    )
}